import createSvgIcon from '@mui/material/utils/createSvgIcon';

const DbEncryption = createSvgIcon(
  <svg
    viewBox="0 0 49 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 10.0367V21.8182C6.5 32.8951 14.2214 43.2242 24.5 45.9377C34.7786 43.2242 42.5 32.8951 42.5 21.8182V10.0367L24.5 2.18212L6.5 10.0367ZM24.5 0L4.5 8.72727V21.8182C4.5 33.9273 13.0333 45.2509 24.5 48C35.9667 45.2509 44.5 33.9273 44.5 21.8182V8.72727L24.5 0ZM15.5 21.5C15.5 20.6716 16.1716 20 17 20H18.5V18.1999C18.5 16.6087 19.1321 15.0825 20.2574 13.9573C21.3826 12.8321 22.9087 12.2 24.5 12.2C26.0913 12.2 27.6174 12.8321 28.7426 13.9573C29.8679 15.0825 30.5 16.6087 30.5 18.2V20H32C32.8284 20 33.5 20.6716 33.5 21.5V32.5C33.5 33.3284 32.8284 34 32 34H17C16.1716 34 15.5 33.3284 15.5 32.5V21.5ZM28.5 20V18.2C28.5 17.1391 28.0786 16.1217 27.3284 15.3715C26.5783 14.6214 25.5609 14.2 24.5 14.2C23.4391 14.2 22.4217 14.6214 21.6716 15.3715C20.9214 16.1217 20.5 17.1391 20.5 18.1999V20H28.5Z"
    />
  </svg>,
  'DbEncryption')

export default DbEncryption;
